// extracted by mini-css-extract-plugin
module.exports = {"DefaultIcon":"Icon_DefaultIcon__2129o"};